// extracted by mini-css-extract-plugin
export default {"root":"DocLocator_root__sDSWU"};